<template>
	<div class="">
		<form @submit.stop.prevent class="w-full">
			<div class="w-full text-sm text-ihh-form-input-entry space-y-2">
				<!-- Name -->
				<div class="w-full md:flex md:justify-between md:space-x-2">
					<div class="w-full mb-2 md:mb-0">
						<div class="relative w-full my-1 rounded border ihh-form-border bg-ihh-form-background transition-all focus-within:border-ihh-dark-salmon">
							<input
								id="firstName"
								v-model="newAddress.firstName"
								type="text"
								class="peer w-full border-none bg-transparent px-2.5 pt-6 pb-2 text-sm ihh-form-input-entry focus:outline-none"
								placeholder=" "
								autocomplete="given-name"
							/>
							<label
								for="firstName"
								class="absolute left-2.5 top-2 text-xs ihh-form-input-label transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:-translate-y-0 peer-focus:text-xs"
							>
								First Name
							</label>
						</div>
					</div>
					<div class="w-full">
						<div class="relative w-full my-1 rounded border ihh-form-border bg-ihh-form-background transition-all focus-within:border-ihh-dark-salmon">
							<input
								id="lastName"
								v-model="newAddress.lastName"
								type="text"
								class="peer w-full border-none bg-transparent px-2.5 pt-6 pb-2 text-sm ihh-form-input-entry focus:outline-none"
								placeholder=" "
								autocomplete="family-name"
							/>
							<label
								for="lastName"
								class="absolute left-2.5 top-2 text-xs ihh-form-input-label transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:-translate-y-0 peer-focus:text-xs"
							>
								Last Name
							</label>
						</div>
					</div>
				</div>

				<!-- Company -->
				<div class="relative w-full my-1 rounded border ihh-form-border bg-ihh-form-background transition-all focus-within:border-ihh-dark-salmon">
					<input
						id="company"
						v-model="newAddress.company"
						type="text"
						class="peer w-full border-none bg-transparent px-2.5 pt-6 pb-2 text-sm ihh-form-input-entry focus:outline-none"
						placeholder=" "
						autocomplete="organization"
					/>
					<label
						for="company"
						class="absolute left-2.5 top-2 text-xs ihh-form-input-label transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:-translate-y-0 peer-focus:text-xs"
					>
						<span>Company</span><span class="text-ihh-form-input-optional ml-1">(Optional)</span>
					</label>
				</div>

				<!-- Address -->
				<div class="relative w-full my-1 rounded border ihh-form-border bg-ihh-form-background transition-all focus-within:border-ihh-dark-salmon">
					<input
						id="shipping-autocomplete"
						v-model="newAddress.address1"
						type="text"
						class="peer w-full border-none bg-transparent px-2.5 pt-6 pb-2 text-sm ihh-form-input-entry focus:outline-none transition-all duration-300"
						:class="{ 'ring-ihh-dark-salmon border-ihh-dark-salmon ring-1 rounded-md': tempFocusFields.includes('address1') }"
						placeholder=" "
						ref="addressInput"
						autocomplete="shipping street-address"
					/>
					<label
						for="shipping-autocomplete"
						class="absolute left-2.5 top-2 text-xs ihh-form-input-label transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:-translate-y-0 peer-focus:text-xs"
					>
						Address
					</label>
				</div>

				<!-- Apartment/Suite/Building -->
				<div class="relative w-full my-1 rounded border ihh-form-border bg-ihh-form-background transition-all focus-within:border-ihh-dark-salmon">
					<input
						id="address2"
						v-model="newAddress.address2"
						type="text"
						class="peer w-full border-none bg-transparent px-2.5 pt-6 pb-2 text-sm ihh-form-input-entry focus:outline-none"
						placeholder=" "
						autocomplete="address-line2"
					/>
					<label
						for="address2"
						class="absolute left-2.5 top-2 text-xs ihh-form-input-label transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:-translate-y-0 peer-focus:text-xs"
					>
						<span>Apartment/Suite/Building</span><span class="text-ihh-form-input-optional ml-1">(Optional)</span>
					</label>
				</div>

				<!-- City & State -->
				<!-- <div class="w-full flex justify-between space-x-2"> -->
				<div class="w-full md:flex md:justify-between md:space-x-2">
					<div class="w-full mb-2 md:mb-0">
						<div class="relative w-full my-1 rounded border ihh-form-border bg-ihh-form-background transition-all focus-within:border-ihh-dark-salmon">
							<input
								id="city"
								v-model="newAddress.city"
								type="text"
								class="peer w-full border-none bg-transparent px-2.5 pt-6 pb-2 text-sm ihh-form-input-entry focus:outline-none transition-all duration-300"
								:class="{ 'ring-ihh-dark-salmon border-ihh-dark-salmon ring-1 rounded-md': tempFocusFields.includes('city') }"
								placeholder=" "
								autocomplete="address-level2"
							/>
							<label
								for="city"
								class="absolute left-2.5 top-2 text-xs ihh-form-input-label transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:-translate-y-0 peer-focus:text-xs"
							>
								City
							</label>
						</div>
					</div>
					<div class="w-full">
						<div class="relative w-full my-1 rounded border ihh-form-border bg-ihh-form-background transition-all focus-within:border-ihh-dark-salmon">
							<select
								id="stateOrProvince"
								v-model="newAddress.stateOrProvince"
								type="text"
								class="appearance-none peer w-full border-none bg-transparent px-2.5 pt-6 pb-2 text-sm ihh-form-input-entry focus:outline-none transition-all duration-300"
								:class="{ 'ring-ihh-dark-salmon border-ihh-dark-salmon ring-1 rounded-md': tempFocusFields.includes('stateOrProvince') }"
								placeholder=" "
								autocomplete="address-level1"
							>
								<option value="" disabled>Select a state</option>
								<option v-for="state in states" :key="state.name" :value="state.name">{{ state.name }}</option>
							</select>
							<label
								for="stateOrProvince"
								class="absolute left-2.5 top-2 text-xs ihh-form-input-label transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:-translate-y-0 peer-focus:text-xs"
							>
								State/Province
							</label>
						</div>
					</div>
				</div>

				<!-- Postal Code -->
				<div class="relative w-full my-1 rounded border ihh-form-border bg-ihh-form-background transition-all focus-within:border-ihh-dark-salmon">
					<input
						id="postalCode"
						v-model="newAddress.postalCode"
						type="string"
						class="peer w-full border-none bg-transparent px-2.5 pt-6 pb-2 text-sm ihh-form-input-entry focus:outline-none transition-all duration-300"
						:class="{ 'ring-ihh-dark-salmon border-ihh-dark-salmon ring-1 rounded-md': tempFocusFields.includes('postalCode') }"
						placeholder=" "
						autocomplete="postal-code"
					/>
					<label
						for="postalCode"
						class="absolute left-2.5 top-2 text-xs ihh-form-input-label transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:-translate-y-0 peer-focus:text-xs"
					>
						Postal Code
					</label>
				</div>

				<!-- Country -->
				<div class="relative w-full my-1 rounded border ihh-form-border bg-ihh-form-background transition-all focus-within:border-ihh-dark-salmon">
					<select
						@change="fetchStates"
						v-model="newAddress.countryCode"
						id="countryCode"
						type="text"
						class="appearance-none peer w-full border-none bg-transparent px-2.5 pt-6 pb-2 text-sm ihh-form-input-entry focus:outline-none transition-all duration-300"
						:class="{ 'ring-ihh-dark-salmon border-ihh-dark-salmon ring-1 rounded-md': tempFocusFields.includes('countryCode') }"
						placeholder=" "
						autocomplete="country"
					>
						<option value="" disabled>Select Country</option>
						<option v-for="country in countries" :key="country.isoCode" :value="country.isoCode">{{ country.name }}</option>
					</select>
					<label
						for="countryCode"
						class="absolute left-2.5 top-2 text-xs ihh-form-input-label transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:-translate-y-0 peer-focus:text-xs"
					>
						Country
					</label>
				</div>

				<!-- Due Date -->
				<div class="w-full flex space-x-2 justify-between md:justify-start">
					<div class="w-full md:w-1/3">
						<div class="relative w-full my-1 rounded border ihh-form-border bg-ihh-form-background transition-all focus-within:border-ihh-dark-salmon">
							<input
								id="dueDate"
								v-model="newAddress.dueDate"
								type="date"
								placeholder=" "
								class="peer w-full border-none bg-transparent px-2.5 pt-6 pb-2 text-sm ihh-form-input-entry focus:outline-none"
							/>
							<label
								for="dueDate"
								class="absolute left-2.5 top-2 text-xs ihh-form-input-label transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:-translate-y-0 peer-focus:text-xs"
							>
								<span>Due Date</span><span class="text-ihh-form-input-optional ml-1">(Optional)</span>
							</label>
						</div>
					</div>
					<div class="hidden md:flex items-center">
						<button type="button" @click="resetDueDate">
							<svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#453c50">
								<path
									d="M444-144q-107-14-179.5-94.5T192-430q0-61 23-113.5t63-91.5l51 51q-30 29-47.5 69T264-430q0 81 51.5 140T444-217v73Zm72 0v-73q77-13 128.5-72.5T696-430q0-90-63-153t-153-63h-7l46 46-51 50-132-132 132-132 51 51-45 45h6q120 0 204 84t84 204q0 111-72.5 192T516-144Z"
								/>
							</svg>
						</button>
					</div>
				</div>

				<!-- Phone number -->
				<div class="relative w-full my-1 rounded border ihh-form-border bg-ihh-form-background transition-all focus-within:border-ihh-dark-salmon">
					<input
						@input="formatPhoneNumber($event)"
						id="phoneNumber"
						:value="formattedPhoneNumber"
						type="tel"
						class="peer w-full border-none bg-transparent px-2.5 pt-6 pb-2 text-sm ihh-form-input-entry focus:outline-none"
						placeholder=" "
						autocomplete="tel"
					/>
					<label
						for="phoneNumber"
						class="absolute left-2.5 top-2 text-xs ihh-form-input-label transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:-translate-y-0 peer-focus:text-xs"
					>
						Phone Number
					</label>
				</div>

				<!-- HC Provider -->
				<div class="w-full">
					<div class="text-ihh-slate-gray text-sm items-center text-start">Are you a healthcare provider?</div>
					<div class="m-auto mt-1 items-center flex w-full">
						<div class="flex items-center m-auto w-full pr-4">
							<label
								for="hcProvider"
								class="custom-checkbox relative inline-block overflow-hidden w-4 h-4 bg-transparent rounded border border-gray-300 cursor-pointer mr-2"
							>
								<input id="hcProvider" type="checkbox" v-model="newAddress.hcProvider" class="absolute opacity-0 w-0 h-0" />
								<span class="checkmark absolute inset-0 flex items-center justify-center hidden text-ihh-white/90 text-lg">✓</span>
							</label>
							<div class="text-ihh-slate-gray text-sm items-center text-start">Yes <span class="text-ihh-form-input-optional ml-1">(Optional)</span></div>
						</div>
					</div>
				</div>

				<div class="m-auto my-3 items-center flex w-full">
					<div class="flex items-center m-auto w-full pr-4">
						<label class="custom-checkbox relative inline-block overflow-hidden w-4 h-4 bg-transparent rounded border border-gray-300 cursor-pointer mr-2">
							<input type="checkbox" v-model="localBillingMatchesShipping" class="absolute opacity-0 w-0 h-0" />
							<span class="checkmark absolute inset-0 flex items-center justify-center hidden text-ihh-white/90 text-lg">✓</span>
						</label>
						<div class="text-ihh-slate-gray text-sm items-center text-start">My billing address is the same as my shipping address.</div>
					</div>
				</div>

				<!-- <div v-if="store?.user?.id" class="m-auto items-center flex w-full">
					<div class="flex items-center m-auto w-full pr-4">
						<label class="custom-checkbox relative inline-block overflow-hidden w-4 h-4 bg-transparent rounded border border-gray-300 cursor-pointer mr-2">
							<input type="checkbox" v-model="saveNewAddress" class="absolute opacity-0 w-0 h-0" />
							<span class="checkmark absolute inset-0 flex items-center justify-center hidden text-ihh-white/90 text-lg">✓</span>
						</label>
						<div class="text-ihh-slate-gray text-sm items-center text-start">Save this address in my address book.</div>
					</div>
				</div> -->

				<div class="w-full flex justify-center md:justify-start">
					<button
						@click="saveAddress"
						class="flex w-full justify-center md:max-w-40 text-cendter mt-4 uppercase bg-ihh-dark-salmon hover:bg-ihh-salmon ease-in-out duration-100 transition text-ihh-midnight-gray font-semibold tracking-wide py-3 px-4 text-sm rounded items-center"
					>
						{{ this.checkout.shippingAddressValidated.value ? 'Update' : 'Continue' }}
					</button>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import { Country, State } from 'country-state-city'
import { debounce } from 'lodash'
import Swal from 'sweetalert2'
import { useCheckoutStore } from '../../stores/store.js'

export default {
	inject: ['store'],
	emits: ['newAddressCompleted', 'saveNewAddress'],
	props: {
		enableAutoComplete: {
			type: Boolean,
			default: false,
		},
		showAddressForm: {
			type: Boolean,
			default: false,
		},
	},
	name: 'ShippingAddressForm',
	data() {
		return {
			countries: [],
			states: [],
			creatingAddress: true,
			updatingAddress: false,
			editingAddressId: null,
			tempFocusFields: [],
			newAddress: {
				address1: '',
				address2: '',
				city: '',
				company: '',
				firstName: '',
				lastName: '',
				phone: '',
				postalCode: '',
				stateOrProvince: '',
				countryCode: 'US',
				hcProvider: false,
				dueDate: null,
			},
			addresses: [],
			required: ['firstName', 'lastName', 'address1', 'city', 'stateOrProvince', 'postalCode', 'countryCode', 'phone'],
			formattedPhoneNumber: '',
			missingFields: [],
			addressValidated: false,
			saveNewAddress: false,
			localBillingMatchesShipping: false,
			checkout: useCheckoutStore(),
		}
	},
	created() {
		this.fetchCountries()
		this.states = State.getStatesOfCountry('US')
	},

	mounted() {
		// Only set billingMatchesShipping to true on first load when billing address is empty
		if (!this.checkout.billingAddressValidated.value) {
			// This is the first time loading the shipping address and billing is empty
			this.localBillingMatchesShipping = true
		}

		if (this.checkout.shippingAddressValidated.value) {
			this.copyStoreAddressToLocal()
		}

		// wait 2 seconds before continuing
		setTimeout(() => {
			if (this.enableAutoComplete && typeof google !== 'undefined') {
				this.initAutoComplete()
			}
		}, 1000)
	},

	methods: {
		saveAddress() {
			this.validateAddress()
			if (!this.addressValidated) {
				Swal.fire({
					icon: 'warning',
					title: 'Missing Information',
					html: this.missingFields.length
						? `<div class="text-center mb-3">Please enter the following fields to continue:</div>
						   <div class="text-center text-sm px-4 py-3 bg-gray-50 rounded-md mx-auto max-w-xs">
						     ${this.missingFields.map((field) => `<div class="py-1 border-b border-gray-200 last:border-0">${field}</div>`).join('')}
						   </div>`
						: 'Please enter all required fields to continue',
					confirmButtonColor: '#e59789',
				})
				return
			}

			this.updateAddress(JSON.parse(JSON.stringify(this.newAddress)))
		},
		copyStoreAddressToLocal() {
			console.log('copying store address to local')
			this.newAddress.address1 = this.checkout.shipping.shippingAddress.address1
			this.newAddress.address2 = this.checkout.shipping.shippingAddress.address2
			this.newAddress.city = this.checkout.shipping.shippingAddress.city
			this.newAddress.company = this.checkout.shipping.shippingAddress.company
			this.newAddress.countryCode = this.checkout.shipping.shippingAddress.countryCode
			this.newAddress.firstName = this.checkout.shipping.shippingAddress.firstName
			this.newAddress.lastName = this.checkout.shipping.shippingAddress.lastName
			this.newAddress.phone = this.checkout.shipping.shippingAddress.phone
			this.newAddress.postalCode = this.checkout.shipping.shippingAddress.postalCode
			this.newAddress.stateOrProvince = this.checkout.shipping.shippingAddress.stateOrProvince
			this.newAddress.hcProvider = this.checkout.shipping.shippingAddress.hcProvider
			this.newAddress.dueDate = this.checkout.shipping.shippingAddress.dueDate

			if (this.checkout.shipping.shippingAddress?.id) {
				this.newAddress.id = this.checkout.shipping.shippingAddress.id
			}
			this.initializeFormattedPhoneNumber()
		},
		applyTempFocusStyling(fieldNames) {
			// Clear any existing temporary focus fields
			this.tempFocusFields = []

			// Add the new fields to focus
			this.tempFocusFields = [...fieldNames]

			// Remove the focus after 1500ms
			setTimeout(() => {
				this.$nextTick(() => {
					this.tempFocusFields = []
				})
			}, 1200)
		},
		fetchCountries() {
			console.log('fetching countries')
			this.countries = Country.getAllCountries()
		},
		fetchStates() {
			if (this.newAddress.countryCode) {
				this.states = State.getStatesOfCountry(this.newAddress.countryCode)
			}
		},
		fetchStateName(stateCode, countryCode) {
			return State.getStateByCode(stateCode, countryCode).name
		},
		validateAddress() {
			console.log('validating new address...')
			const missingFields = []
			const fieldValidationStatus = []

			// Check validation status for each required field
			for (const field of this.required) {
				let isValid = true
				let displayName = this.getFieldDisplay(field)

				if (!this.newAddress[field]) {
					missingFields.push(displayName)
					isValid = false
				} else if (field === 'phone' && this.required.includes('phone')) {
					// Check if phone is required and has 10 digits
					const digitsOnly = this.newAddress.phone.replace(/\D/g, '')
					if (digitsOnly.length !== 10) {
						missingFields.push('Phone Number (must be 10 digits)')
						isValid = false
						displayName = 'Phone Number'
					}
				}

				// Add field validation status to the array
				fieldValidationStatus.push({
					name: displayName,
					field: field,
					validated: isValid,
				})
			}
			this.missingFields = missingFields

			if (missingFields.length > 0) {
				this.addressValidated = false
				console.log(`discovered missing fields in address ${missingFields.join(', ')}`)
				return { missingFields: true, message: `Please enter the following fields: ${missingFields.join(', ')}` }
			} else {
				this.addressValidated = true
				// console.log('address validated', this.newAddress)

				// this.updateAddress(JSON.parse(JSON.stringify(this.newAddress)))

				return { missingFields: false }
			}
		},
		getFieldDisplay(field) {
			const displayMap = {
				address1: 'Street Address',
				address2: 'Apt/Suite/Room',
				city: 'City',
				company: 'Company Name',
				firstName: 'First Name',
				lastName: 'Last Name',
				phone: 'Phone Number',
				postalCode: 'Postal Code',
				stateOrProvince: 'State/Province',
				countryCode: 'Country',
			}
			return displayMap[field] || field
		},
		updateAddress(address) {
			this.checkout.setShippingAddress(JSON.parse(JSON.stringify(address)))
			this.$emit('newAddressCompleted') // passes event up through address-details.vue to parent to trigger fetching shipping options
		},

		formatCountry(countryName) {
			const country = Country.getAllCountries().find((c) => c.name === countryName)
			return country ? country.isoCode : null
		},

		formatPhoneNumber(event) {
			// Only allow numerical digits
			const input = event.target.value.replace(/\D/g, '')

			// Store the raw digits in the newAddress.phone property
			this.newAddress.phone = input

			// Format with dashes for display
			let formatted = ''
			if (input.length <= 3) {
				formatted = input
			} else if (input.length <= 6) {
				formatted = `${input.slice(0, 3)}-${input.slice(3)}`
			} else {
				formatted = `${input.slice(0, 3)}-${input.slice(3, 6)}-${input.slice(6, 10)}`
			}

			// Save the formatted value for display
			this.formattedPhoneNumber = formatted

			// Trigger validation
			// this.debouncedValidateAddress()
		},
		initializeFormattedPhoneNumber() {
			if (this.newAddress && this.newAddress.phone) {
				const input = this.newAddress.phone.replace(/\D/g, '')

				// Format with dashes for display
				let formatted = ''
				if (input.length <= 3) {
					formatted = input
				} else if (input.length <= 6) {
					formatted = `${input.slice(0, 3)}-${input.slice(3)}`
				} else {
					formatted = `${input.slice(0, 3)}-${input.slice(3, 6)}-${input.slice(6, 10)}`
				}

				// Save the formatted value for display
				this.formattedPhoneNumber = formatted
			}
		},
		resetDueDate() {
			console.log('date value: ', this.newAddress.dueDate)
			// Use null instead of empty string for Safari compatibility
			this.newAddress.dueDate = null

			// Use $nextTick to ensure DOM updates properly
			this.$nextTick(() => {
				// Force a re-render of the input
				const dateInput = this.$el.querySelector('input[type="date"]')
				if (dateInput) {
					dateInput.value = ''
				}
			})
		},
		resetAddressForm() {
			this.newAddress = {
				address1: '',
				address2: '',
				city: '',
				company: '',
				countryCode: '',
				firstName: '',
				lastName: '',
				phone: '',
				postalCode: '',
				stateOrProvince: '',
				countryCode: 'US',
				hcProvider: false,
				dueDate: null,
			}
			this.resetDueDate()
			this.formattedPhoneNumber = ''
		},
		copyShippingToBilling() {
			if (!this.checkout.shipping.shippingAddress) return
			const address = JSON.parse(JSON.stringify(this.checkout.shipping.shippingAddress))
			address.hcProvider = false
			address.dueDate = ''
			this.newAddress = address
		},

		initAutoComplete() {
			this.$nextTick(() => {
				const autocompleteId = 'shipping-autocomplete'
				const autocompleteElement = document.getElementById(autocompleteId)

				if (!autocompleteElement) {
					console.error(`Could not find element with id ${autocompleteId}`)
					return
				}

				const autocomplete = new google.maps.places.Autocomplete(autocompleteElement, { types: ['address'] })

				autocomplete.addListener('place_changed', () => {
					const place = autocomplete.getPlace()
					const addressComponents = place?.address_components?.reduce((acc, component) => {
						const types = component.types
						if (types.includes('street_number')) {
							acc.street_number = component.long_name
						} else if (types.includes('route')) {
							acc.route = component.long_name
						} else if (types.includes('locality')) {
							acc.city = component.long_name
						} else if (types.includes('administrative_area_level_1')) {
							acc.state = component.long_name
						} else if (types.includes('country')) {
							acc.country = component.short_name
						} else if (types.includes('postal_code')) {
							acc.postal_code = component.long_name
						}
						return acc
					}, {})

					console.log('Google Places addressComponents: ', addressComponents)

					// Update the form data
					this.newAddress.address1 = `${addressComponents.street_number || ''} ${addressComponents.route || ''}`.trim()
					this.newAddress.city = addressComponents.city || ''
					this.newAddress.stateOrProvince = addressComponents.state || ''
					this.newAddress.postalCode = addressComponents.postal_code || ''
					this.newAddress.countryCode = addressComponents.country || ''

					// Apply temporary focus styling to updated fields
					this.applyTempFocusStyling(['address1', 'city', 'stateOrProvince', 'postalCode', 'countryCode'])

					// Fetch states for the selected country
					if (addressComponents.country) {
						this.fetchStates()
					}
				})
			})
		},
	},

	watch: {
		enableAutoComplete: {
			handler(newVal) {
				if (newVal && typeof google !== 'undefined') {
					this.initAutoComplete()
				}
			},
			immediate: false,
		},
		showAddressForm: {
			handler(newVal) {
				if (newVal && this.checkout.shippingAddressValidated.value) {
					this.copyStoreAddressToLocal()
				}

				if (newVal) {
					this.localBillingMatchesShipping = this.checkout.shipping.billingMatchesShipping
				}
			},
		},
		saveNewAddress: {
			handler(newVal) {
				console.log('saveNewAddress', newVal)
				this.$emit('saveNewAddress', newVal)
			},
		},
		localBillingMatchesShipping: {
			handler(newVal) {
				this.checkout.updateBillingMatchesShipping(newVal)
			},
		},
		'newAddress.countryCode': {
			handler(newVal) {
				if (newVal !== 'US') {
					this.required = ['firstName', 'lastName', 'address1', 'city', 'countryCode', 'phone']
				} else {
					this.required = ['firstName', 'lastName', 'address1', 'city', 'stateOrProvince', 'postalCode', 'countryCode', 'phone']
				}
			},
		},
	},
}
</script>

<style scoped></style>
